module.exports = __webpack_public_path__ + "static/media/Ancients.d89a7476.png";